export type Environment = 'prod' | 'qa' | 'dev' | 'local';

export const environmentNames = {
  PROD: 'prod',
  QA: 'qa',
  DEV: 'dev',
  LOCAL: 'local',
} as const;

/**
 * Valid environment names
 */
export const validEnvironments: Environment[] = [
  environmentNames.PROD,
  environmentNames.QA,
  environmentNames.DEV,
  environmentNames.LOCAL,
];

export type EnvironmentConstants = {
  environmentName: Environment;

  webapp: {
    apiV2Url: string;
    apiLegacyUrl: string;
    appUrl: string;
  };

  livefire: {
    baseUrl: string;
  };

  ves: {
    baseUrl: string;
    saveEnvironment: string;
  };

  metro: {
    baseUrl: string;
  };

  yardstic: {
    baseUrl: string;
  };

  reaction: {
    baseUrl: string;
  };
};

/**
 * Holds constants for various environments
 * @type {Record<Environment, EnvironmentConstants>}
 */
export const environmentConstants = {
  prod: {
    environmentName: environmentNames.PROD,
    webapp: {
      apiV2Url: 'https://api.bombbomb.com/v2/',
      apiLegacyUrl: 'https://app.bombbomb.com/app/api/api.php',
      appUrl: 'https://app.bombbomb.com/',
    },
    livefire: {
      baseUrl: 'https://livefire.bombbomb.com',
    },
    ves: {
      baseUrl: 'https://video.bombbomb.io',
      saveEnvironment: '', // empty since VES treats this as prod
    },
    metro: {
      baseUrl: 'https://metro.bombbomb.io',
    },
    yardstick: {
      baseUrl: 'https://yardstick.bombbomb.io',
    },
    reaction: {
      baseUrl: 'https://reaction.bombbomb.io',
    },
    securityTransfer: {
      baseUrl: 'https://video-security-transfers.bombbomb.io/',
    },
  },
  qa: {
    environmentName: environmentNames.QA,
    webapp: {
      apiV2Url: 'https://api.qa.bombbomb.io/v2/',
      apiLegacyUrl: 'https://app.qa.bombbomb.io/app/api/api.php',
      appUrl: 'https://app.qa.bombbomb.io/',
    },
    livefire: {
      // QA livefire doesn't yet exist
      baseUrl: 'https://qa-livefire.bombbomb.com',
    },
    ves: {
      baseUrl: 'https://qa-video.dev.bombbomb.io',
      saveEnvironment: 'QA',
    },
    metro: {
      baseUrl: 'https://development-metro.dev.bombbomb.io',
    },
    yardstick: {
      baseUrl: 'https://yardstick.bombbomb.io',
    },
    reaction: {
      baseUrl: 'https://dev-reaction.dev.bombbomb.io',
    },
    securityTransfer: {
      baseUrl: 'https://dev-video-security-transfers.dev.bombbomb.io/',
    },
  },
  dev: {
    environmentName: environmentNames.DEV,
    webapp: {
      apiV2Url: 'https://dev.api.bombbomb.com/v2/',
      apiLegacyUrl: 'https://dev.app.bombbomb.com/app/api/api.php',
      appUrl: 'https://dev.app.bombbomb.com/',
    },
    livefire: {
      baseUrl: 'https://dev-livefire.bombbomb.com',
    },
    ves: {
      baseUrl: 'https://development-video.dev.bombbomb.io',
      saveEnvironment: 'DEV',
    },
    metro: {
      baseUrl: 'https://development-metro.dev.bombbomb.io',
    },
    yardstick: {
      baseUrl: 'https://yardstick.bombbomb.io',
    },
    reaction: {
      baseUrl: 'https://dev-reaction.dev.bombbomb.io',
    },
    securityTransfer: {
      baseUrl: 'https://dev-video-security-transfers.dev.bombbomb.io/',
    },
  },
  local: {
    environmentName: environmentNames.LOCAL,
    webapp: {
      apiV2Url: 'https://local.api.bombbomb.com/v2/',
      apiLegacyUrl: 'https://local.app.bombbomb.com/app/api/api.php',
      appUrl: 'https://local.app.bombbomb.com/',
    },
    livefire: {
      // TODO I don't think this exists, what was previous functionality?
      baseUrl: 'https://local-livefire.bombbomb.com',
    },
    ves: {
      // if running on local, we still talk to DEV VES
      baseUrl: 'https://development-video.dev.bombbomb.io',
      saveEnvironment: 'DEV',
    },
    metro: {
      baseUrl: 'https://development-metro.dev.bombbomb.io',
    },
    yardstick: {
      baseUrl: 'https://yardstick.bombbomb.io',
    },
    // if running on local, we still talk to DEV reaction service
    reaction: {
      baseUrl: 'https://dev-reaction.dev.bombbomb.io',
    },
    securityTransfer: {
      baseUrl: 'http://localhost:9982',
    },
  },
};
